import React, { createContext, useState, useCallback } from "react";
import * as pdfjsLib from "pdfjs-dist";

// This must point to the .js file
pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.js`;

export const FileContext = createContext();

export const FileProvider = ({ children }) => {
  const [files, setFiles] = useState([]);

  const addFiles = useCallback(async (acceptedFiles) => {
    const newFiles = await Promise.all(
      acceptedFiles.map(async (file) => {
        try {
          const arrayBuffer = await file.arrayBuffer();
          const pdf = await pdfjsLib.getDocument(arrayBuffer).promise;
          const page = await pdf.getPage(1);
          const viewport = page.getViewport({ scale: 0.5 });

          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          await page.render({ canvasContext: context, viewport }).promise;

          return {
            id: `${file.name}-${Date.now()}`,
            fileObject: file,
            name: file.name,
            thumbnail: canvas.toDataURL(),
          };
        } catch (error) {
          console.error("Failed to process file:", file.name, error);
          return null;
        }
      })
    );

    setFiles((currentFiles) => [...currentFiles, ...newFiles.filter(Boolean)]);
  }, []);

  const removeFile = useCallback((fileId) => {
    setFiles((currentFiles) => currentFiles.filter((f) => f.id !== fileId));
  }, []);

  const clearFiles = useCallback(() => {
    setFiles([]);
  }, []);

  const reorderFiles = useCallback((startIndex, endIndex) => {
    setFiles((currentFiles) => {
      const result = Array.from(currentFiles);
      const [removed] = result.splice(startIndex, 1);
      result.splice(endIndex, 0, removed);
      return result;
    });
  }, []);

  const value = { files, addFiles, removeFile, clearFiles, reorderFiles };

  return <FileContext.Provider value={value}>{children}</FileContext.Provider>;
};
